<template>
  <div :class="classes">
    <div class="c-info__container">
      <svg
        class="c-info__icon"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 53 53"
      >
        <path fill="#292983" d="M27 52a25 25 0 100-50 25 25 0 000 50z" />
        <path
          fill="#fff"
          fill-rule="evenodd"
          d="M24.85 22.8c.38-.95-.11-1.43-.55-1.43-2.01 0-4.63 4.64-5.6 4.64a.75.75 0 01-.72-.7c0-.96 2.4-3.2 3.1-3.89a12.2 12.2 0 018.17-3.57c2.34 0 4.85 1.39 2.89 6.56L28.23 34.8a10 10 0 00-.93 2.98.68.68 0 00.65.75c1.64 0 4.63-4.53 5.4-4.53a.78.78 0 01.65.8c0 1.55-6.37 8.16-11.87 8.16-1.97 0-3.33-.91-3.33-2.94 0-2.55 1.85-6.92 2.24-7.83l3.8-9.38zm2.94-10.5a4.42 4.42 0 014.47-4.25A3.52 3.52 0 0136 11.67a4.37 4.37 0 01-4.52 4.26 3.45 3.45 0 01-3.7-3.62z"
          clip-rule="evenodd"
        />
      </svg>
      <div class="c-info__text" v-html="content.text" />
    </div>
    <div v-if="content.more" class="c-info__more" v-html="content.more" />
  </div>
</template>

<script>
import contentComponent from "@/mixins/content";

export default {
  name: "c-info",
  mixins: [contentComponent],
};
</script>

<style lang="scss" scoped>
.c-info {
  background: #fff;
  font-weight: 300;
  padding: 2rem;
  border-radius: 0.5rem;
  max-width: 90%;
  font-size: 1.125rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  &__container {
    display: flex;
    align-items: center;
  }

  &__more {
    padding: 2rem 0 0 0;

    @include media-breakpoint-down(xl) {
      padding-top: 1.5rem;
    }
    @include media-breakpoint-down(lg) {
      padding-top: 1.25rem;
    }
    @include media-breakpoint-down(md) {
      padding-top: 1rem;
    }
  }

  &--noshadow {
    box-shadow: none;
  }

  @include media-breakpoint-down(xl) {
    font-size: 1rem;
    padding: 1.5rem;
  }

  @include media-breakpoint-down(lg) {
    font-size: 0.75rem;
    padding: 1.25rem;
  }

  ::v-deep {
    p {
      margin: 0;

      + ul,
      + ol,
      + p {
        margin-top: 1em;

        @include media-breakpoint-down(xl) {
          margin-top: 0.75em;
        }
        @include media-breakpoint-down(lg) {
          margin-top: 0.5em;
        }
      }
    }

    ol,
    ul {
      padding: 0;
      margin: 0 0 0 1em;

      @include media-breakpoint-down(xl) {
        margin-top: 0.75em;
      }
      @include media-breakpoint-down(lg) {
        margin-top: 0.5em;
      }
    }
    b {
      font-weight: bold;
    }
  }
  &__icon {
    width: 53px;
    height: 53px;
    flex-shrink: 0;
    margin: 0 2rem 0 0;

    @include media-breakpoint-down(xl) {
      width: 3rem;
      height: 3rem;
      margin: 0 1.5rem 0 0;
    }
    @include media-breakpoint-down(lg) {
      width: 2rem;
      height: 2rem;
      margin: 0 0.75rem 0 0;
    }
  }
}
</style>
